function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14645 8.85355C3.95118 8.65829 3.95118 8.34171 4.14645 8.14645L6.29289 6L4.14645 3.85355C3.95119 3.65829 3.95119 3.34171 4.14645 3.14645C4.34171 2.95118 4.65829 2.95118 4.85355 3.14645L7.35355 5.64645C7.54882 5.84171 7.54882 6.15829 7.35355 6.35355L4.85355 8.85355C4.65829 9.04882 4.34171 9.04882 4.14645 8.85355Z"
  }));
};

export default SvgComponent;